import React from "react";
import { Field } from "formik";
import {CheckboxCustom, CheckboxLabel, Unchecked} from "./styled/form";
import Check from "../Icons/Check";
import { Messages, Translate } from '../tr';

interface Props {
  id: string,
  name: string,
  value: string,
  label: Messages,
  price: boolean,
}

const Checkbox = (props: Props) => (
  <Field name={props.name}>
    {({ field, form }) => {
      const checked = field.value.includes(props.value);
      return (
        <CheckboxLabel>
          <div style={{ width: 30, flexShrink: 0}}>
          {checked
            ? <Check />
            : <Unchecked />
          }
          </div>
          <CheckboxCustom
            type="checkbox"
            id={props.id}
            name={props.name}
            value={props.value}
            checked={checked}
            onChange={() => {
              if (checked) {
                const nextValue = field.value.filter(
                  value => value !== props.value
                );
                form.setFieldValue(props.name, nextValue);
              } else {
                const nextValue = field.value.concat(props.value);
                form.setFieldValue(props.name, nextValue);
              }
            }}
          /><div><Translate text={props.label} /> {props.price ? <>- <strong>{props.value}Kč</strong></> : ''}</div>
        </CheckboxLabel>
      )
    }}
  </Field>
);

export default Checkbox;
